"use strict";
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var _require = require('react'), useEffect = _require.useEffect, useRef = _require.useRef;
var UppyCore = require('@uppy/core').Uppy;
module.exports = function useUppy(factory) {
    if (typeof factory !== 'function') {
        throw new TypeError('useUppy: expected a function that returns a new Uppy instance');
    }
    var uppy = useRef(undefined);
    if (uppy.current === undefined) {
        uppy.current = factory();
        if (!_instanceof(uppy.current, UppyCore)) {
            throw new TypeError("useUppy: factory function must return an Uppy instance, got ".concat(_type_of(uppy.current)));
        }
    }
    useEffect(function() {
        return function() {
            uppy.current.close();
        };
    }, []);
    return uppy.current;
};
